import { useAppSelector } from '@/app/hooks';
import type { RootState } from '@/app/store';
import { selectIsFreeWithoutLiveAccess } from '@/features/workspace/workspaceSlice';
import UsageExpiredAlert from '@/components/billing/UsageExpiredAlert';
import { isPlanModalDismissed, markPlanModalDismissed } from '@/lib/planModalDismissal';

/**
 * Ouvre la modale de choix de forfait à l'arrivée sur le dashboard d'un compte gratuit,
 * une seule fois par workspace et par navigateur. Les points d'entrée manuels (bandeau,
 * Configuration) restent indépendants de ce marqueur.
 */
export default function FreePlanUpsellModal() {
  const workspaceId = useAppSelector((s: RootState) => s.workspace.currentWorkspace?.id);
  const isFreeWithoutLiveAccess = useAppSelector(selectIsFreeWithoutLiveAccess);

  if (!workspaceId || !isFreeWithoutLiveAccess || isPlanModalDismissed(workspaceId)) return null;

  return (
    <UsageExpiredAlert
      key={workspaceId}
      isConfig
      autoOpen
      onClose={() => markPlanModalDismissed(workspaceId)}
    />
  );
}
